/**
 * Human-readable byte size. `formatBytes(1536)` → "1.5 KB"; `formatBytes(0)`
 * or null → "0 B". Bytes render with no decimals, larger units with one
 * (trailing ".0" trimmed). Used by the Media Files storage-usage meter.
 */
export function formatBytes(bytes) {
    if (!bytes || bytes <= 0)
        return '0 B';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / Math.pow(1024, i);
    const str = i === 0 ? String(Math.round(value)) : value.toFixed(1).replace(/\.0$/, '');
    return `${str} ${units[i]}`;
}
